import { render, staticRenderFns } from "./reports.page.vue?vue&type=template&id=603968d1&scoped=true"
import script from "./reports.page.vue?vue&type=script&lang=js"
export * from "./reports.page.vue?vue&type=script&lang=js"
import style0 from "./reports.page.vue?vue&type=style&index=0&id=603968d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603968d1",
  null
  
)

export default component.exports